import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Checkbox, Form, FormInstance } from "antd";
import { observer } from "mobx-react";
import { CheckboxChangeEvent } from "antd/lib/checkbox";

interface ReportsFunctionsProps extends WithTranslation {
  groupsForRights: API_Group[];
  reportsModule: boolean;
  formRef: React.RefObject<FormInstance>;
}

interface ReportFunctionsState {
  isChecked: boolean;
}

export const ReportsFunctions = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<ReportsFunctionsProps, ReportFunctionsState> {
      constructor(props: ReportsFunctionsProps) {
        super(props);
        this.state = {
          isChecked: !!props.reportsModule,
        };
      }

      handleCheckboxChange = (e: CheckboxChangeEvent) => {
        const isChecked = e.target.checked;
        this.setState({ isChecked }, () =>
          this.props.formRef.current.setFieldsValue({
            "functions[REPORTS]": isChecked,
          })
        );
      };

      render() {
        const { t, reportsModule } = this.props;
        return (
          <div>
            <h3 style={{ marginTop: 10 }}>{t("Reports")}</h3>
            <div>
              <Form.Item name={["functions", "REPORTS"]} initialValue={reportsModule} valuePropName="checked">
                <Checkbox className="mr-5">{t("Activity reports")}</Checkbox>
              </Form.Item>
            </div>
          </div>
        );
      }
    }
  )
);
